import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dcb2ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Carte Confituur | Projecten", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://www.carteconfituur.be/projects/detail"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Carte Confituur is een grafisch ontwerp bureau te Nazareth-De Pinte. Deze one-woman-business levert uniek grafisch ontwerp."
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "Carte Confituur | Projecten"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://www.carteconfituur.be/projects/detail"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Carte Confituur is een grafisch ontwerp bureau te Nazareth-De Pinte. Deze one-woman-business levert uniek grafisch ontwerp."
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:type",
  content: "article"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:title",
  content: "Carte Confituur | Projecten"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:description",
  content: "Carte Confituur is een grafisch ontwerp bureau te Nazareth-De Pinte. Deze one-woman-business levert uniek grafisch ontwerp."
}, null, -1))
const _hoisted_10 = { class: "projectDetailItem" }
const _hoisted_11 = { class: "projectDetailItemWrapper" }
const _hoisted_12 = { class: "mainWrapper" }
const _hoisted_13 = { class: "description" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "detailTexts" }
const _hoisted_17 = {
  key: 0,
  class: "text detailText"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Klant", -1))
const _hoisted_19 = {
  key: 1,
  class: "text detailText"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Door Carte Confituur", -1))
const _hoisted_21 = {
  key: 2,
  class: "text detailText"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Techniek", -1))
const _hoisted_23 = {
  key: 3,
  class: "text detailText"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tekening", -1))
const _hoisted_25 = { class: "callToActionDiv" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("STUUR ME EEN MAILTJE")
const _hoisted_27 = { class: "imagesWrapper" }
const _hoisted_28 = { class: "images" }
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { class: "credits" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Credits: ")
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "callToActionDiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_1
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_2
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_3
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_4
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_5
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_6
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_7
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_8
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_9
    ])),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_ctx.detailItem?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailItem?.story, (str, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(str), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.hasCustomer(_ctx.detailItem))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.detailItem?.customer), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasByCarte(_ctx.detailItem))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.detailItem?.byCarte), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasTechnique(_ctx.detailItem))
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(_ctx.detailItem?.technique), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasDrawing(_ctx.detailItem))
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.detailItem?.drawing), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", {
                class: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, "TERUG NAAR OVERZICHT"),
              _createVNode(_component_router_link, {
                class: "calltoaction",
                to: "/contact"
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailItem?.images, (img) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "imageWrapper",
                key: img.id
              }, [
                _createElementVNode("img", {
                  src: img.path,
                  alt: _ctx.detailItem?.name
                }, null, 8, _hoisted_29)
              ]))
            }), 128))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailItem?.credits, (credit) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "credit",
                key: credit.id
              }, [
                _createElementVNode("a", {
                  href: credit.url
                }, _toDisplayString(credit.text), 9, _hoisted_32)
              ]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.detailItem?.credits]
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, "TERUG NAAR OVERZICHT")
          ])
        ])
      ])
    ])
  ], 64))
}